import React from 'react';
import {useTranslate} from '../../../hooks';
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import {IconBadge} from '../../../components';
import {PaymentFreeMonthDialogRoutes} from './PaymentFreeMonthDialog';
import {formatDate, useBillsV2, useCountry} from '@resurs-internal/rb-app-api';
import {BaseList} from '@resurs-internal/mui';

export const PaymentFreeMonthDialogSuccess: React.FC<{
  navigate: (key: PaymentFreeMonthDialogRoutes) => void;
}> = ({navigate}) => {
  const translate = useTranslate();
  const country = useCountry();
  const bills = useBillsV2();
  const active = bills.query.data?.statements.filter(
    (e) => e?.paymentFreeMonth?.active,
  );

  const totalAmount = active?.reduce(
    (result, e) => {
      if (!e.amountDue?.amount || !e.amountDue.currency) return result;
      return {
        amount: (result.amount ?? 0) + e.amountDue.amount,
        currency: e.amountDue.currency,
      };
    },
    {amount: 0, currency: 'SEK'},
  );

  return (
    <>
      <DialogContent>
        <Stack spacing={2} alignItems={'center'}>
          <IconBadge type={'font'} icon={'check-circle'} size={'xl'} />
          <Typography variant={'h3'} textAlign={'center'}>
            {translate('payment-free-month.success.subtitle')}
          </Typography>
          <Typography typography={'body1'} sx={{width: '100%'}}>
            {translate('payment-free-month.success.description')}
          </Typography>
          <BaseList
            sx={{width: '100%'}}
            items={[
              ...(active?.map((e) => ({
                id: `${e.id}`,
                title: e.designation ?? '',
                subtitle: formatDate(e.dueDate),
                endAdornment: (
                  <Typography typography={'subtitle2'}>
                    {country.formatAmount(e.amountDue)}
                  </Typography>
                ),
              })) ?? []),
              {
                id: 'total',
                title: 'Total',
                hidden: !totalAmount,
                endAdornment: (
                  <Typography variant={'h4'}>
                    {country.formatAmount(totalAmount)}
                  </Typography>
                ),
              },
            ]}
          />
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          color={'secondary'}
          variant={'text'}
          onClick={() => navigate('update')}>
          {translate('common.back')}
        </Button>
        <Button
          color={'primary'}
          variant={'text'}
          onClick={() => navigate('close')}>
          {translate('common.ok')}
        </Button>
      </DialogActions>
    </>
  );
};
